<template>
  <v-chip :x-small="xsmall" :small="small" class="font-weight-bold" :style="estiloStatus">{{ visita.status }}</v-chip>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    visita: { type: Object },
    xsmall: {type: Boolean, default: false},
    small: {type: Boolean, default: false},
  },  
  computed: {
    ...mapState("visitaTecnica",["configuracoes"]),
    estiloStatus(){          
      if(this.configuracoes.dados)  
        return JSON.parse(this.configuracoes.dados.status_visita.find((sv) => sv.descricao.toLowerCase() == this.visita.status.toLowerCase()).css)
      return {}
    }
  }
};
</script>
